import { render, staticRenderFns } from "./CourseReviewForm.vue?vue&type=template&id=3448294a&"
import script from "./CourseReviewForm.vue?vue&type=script&lang=ts&"
export * from "./CourseReviewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports